module.exports = __webpack_public_path__ + "static/media/3.b1247df9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.jpg
// module id = 396
// module chunks = 1